import React from 'react'
import T from 'prop-types'
import JobsWorkflowAdminJobList from './JobsWorkflowAdminJobList'
import JobsWorkflowAdminJobItem from './JobsWorkflowAdminJobItem'

function JobsWorkflowAdminJob(props) {
  const {
    match: {
      params: { id },
    },
  } = props

  return (
    <div className="content">
      {id ? (
        <JobsWorkflowAdminJobItem {...props} />
      ) : (
        <JobsWorkflowAdminJobList {...props} />
      )}
    </div>
  )
}

JobsWorkflowAdminJob.propTypes = {
  match: T.object.isRequired,
}

export default JobsWorkflowAdminJob
